import React from 'react';
import PropTypes from 'prop-types';
import { Plugins } from '@leverege/plugin';
import { Button, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Util from "../Util.js";
import S from './LatLonEditor.css';
const {
  tIcon
} = I18N.ns('ui-geo-elements.LatLonEditor');
export default class GeoPointObjectEditor extends React.Component {
  static propTypes = {
    value: PropTypes.shape({
      lat: PropTypes.number,
      lon: PropTypes.number
    }),
    buttonVariant: PropTypes.string,
    allowClear: PropTypes.bool
  };
  static defaultProps = {
    value: null,
    buttonVariant: 'linkNoPad|link',
    allowClear: false
  };
  static TYPE = 'latLon';
  static NAME = 'Lat/Lon';
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
    this.latRef = /*#__PURE__*/React.createRef();
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps?.value?.lat !== prevState?.value?.lat && nextProps?.value?.lon !== prevState?.value?.lon) {
      return {
        value: nextProps.value
      };
    }
    return null;
  }
  onChange = (value, event) => {
    const {
      onChange,
      eventData
    } = this.props;
    this.setState({
      value
    }, () => {
      const lat = value?.lat;
      const lon = value?.lon;
      if (typeof lat === 'number' && typeof lon === 'number' && onChange) {
        onChange({
          data: eventData,
          value,
          event
        });
      }
    });
  };
  onLatChange = evt => {
    const {
      value
    } = this.state;
    const valid = Util.isValidLatStr(evt.value);
    let toSend = evt.value.toLowerCase();
    if (!valid) {
      toSend = value?.lat;
    } else if (Number(toSend) === Number(`${Number(toSend)}`)) {
      toSend = Number(toSend);
    } else if (toSend.endsWith('n')) {
      toSend = toSend.slice(0, -1);
    } else if (toSend.endsWith('s')) {
      toSend = `-${toSend.slice(0, -1)}`;
    }
    return this.onChange({
      ...value,
      lat: Util.degToFloat(toSend)
    }, evt?.event);
  };
  onLonChange = evt => {
    const {
      value
    } = this.state;
    const valid = Util.isValidLonStr(evt.value);
    let toSend = evt.value.toLowerCase();
    if (!valid) {
      toSend = value?.lon;
    } else if (Number(toSend) === Number(`${Number(toSend)}`)) {
      toSend = Number(toSend);
    } else if (toSend.endsWith('e')) {
      toSend = toSend.slice(0, -1);
    } else if (toSend.endsWith('w')) {
      toSend = `-${toSend.slice(0, -1)}`;
    }
    return this.onChange({
      ...value,
      lon: Util.degToFloat(toSend)
    }, evt?.event);
  };
  onClear = event => {
    const {
      onChange,
      eventData
    } = this.props;
    this.setState({
      value: null
    }, () => {
      if (onChange) {
        onChange({
          data: eventData,
          value: null,
          event
        });
      }
    });
    this.latRef.current?.focus();
  };
  render() {
    const {
      value
    } = this.state;
    const {
      buttonVariant,
      allowClear
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
      domRef: this.latRef,
      className: S.input,
      hint: "Latitude",
      value: value?.lat ? `${value?.lat}` : null,
      onChange: this.onLatChange,
      eventData: "lat"
    }), /*#__PURE__*/React.createElement(TextInput, {
      className: S.input,
      hint: "Longitude",
      value: value?.lon ? `${value?.lon}` : null,
      onChange: this.onLonChange,
      eventData: "lon"
    }), value?.lat != null && value?.lon != null && allowClear && /*#__PURE__*/React.createElement(Button, {
      variant: buttonVariant,
      icon: tIcon('clear', 'fa fa-fw fa-close'),
      onClick: this.onClear
    }));
  }
}
Plugins.add('GeoPointEditor', {
  type: GeoPointObjectEditor.TYPE,
  name: GeoPointObjectEditor.NAME,
  sortKey: 'a',
  // put at top
  editor: GeoPointObjectEditor
});